import { AxiosInstance, InternalAxiosRequestConfig } from 'axios'

export class AuthorizationHeaderInterceptor {
    constructor(
        private axiosInstance: AxiosInstance,
        private getAccessToken: () => string | null
    ) {
        this.attachInterceptor()
    }

    private attachInterceptor = (): void => {
        this.axiosInstance.interceptors.request.use(this.onBeforeRequestSent)
    }

    private onBeforeRequestSent = (
        config: InternalAxiosRequestConfig
    ): Promise<InternalAxiosRequestConfig> => {
        const accessToken = this.getAccessToken()

        if (accessToken) {
            config.headers.setAuthorization(`Bearer ${accessToken}`)
        }

        return Promise.resolve(config)
    }
}
